import { render, staticRenderFns } from "./TestimonialsOnboarding.vue?vue&type=template&id=160a44ae"
import script from "./TestimonialsOnboarding.vue?vue&type=script&lang=js"
export * from "./TestimonialsOnboarding.vue?vue&type=script&lang=js"
import style0 from "./TestimonialsOnboarding.vue?vue&type=style&index=0&id=160a44ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports